import { FC, PropsWithChildren } from "react";
import classes from './lessonItem.module.scss'
import { ILesson } from "../../model/types";
import { formatUtcToMsk } from "../../../../shared/lib/helpers/formatUtcToMsk";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../../app/store/store";
import { FEATURES, FEATURE_SECTIONS, hasFeature, hasFeatureGrant } from "../../../my";

interface IProps {
    lesson: ILesson;
    showFio?: boolean;
}

export const LessonItem: FC<IProps & PropsWithChildren> = ({lesson, showFio, children}) => {
    const {my} = useAppSelector(state => state.myReducer)
    const canOpenStudent = hasFeature(my, FEATURE_SECTIONS.STUDENTS)
        && hasFeatureGrant(my, FEATURES.STUDENTS.CARD_READ)

    return (
        <tr 
            className={classes.item}
        >
            <td className={classes.id}>
                {formatUtcToMsk(lesson.date)} (мск)
            </td>  
            {
                showFio
                    &&
                <td className={classes.fio}>
                    {canOpenStudent
                        ? <Link to={'/students/' + lesson.student_id}>{lesson.student_full_name}</Link>
                        : lesson.student_full_name}
                </td>
            }
            <td className={classes.duration}>
                {lesson.duration_minutes}
            </td>
            <td className={classes.features}>
                {children}
            </td>
        </tr>
    )
}
